var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wt-col"},[_c('div',{staticClass:"wt-col__head"},[_vm._t("head")],2),_c('div',{staticClass:"wt-col__body",class:{'wt-col__body--scroll':_vm.scroll}},[_vm._t("default")],2),_c('div',{staticClass:"wt-col__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }